import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";

dayjs.extend(duration);

const PaymentExpiryTimer = ({ createdAt }) => {
  const [timeLeft, setTimeLeft] = useState("");

  useEffect(() => {
    const expiryDate = new Date(createdAt);
    expiryDate.setDate(expiryDate.getDate() + 7); 

    const updateTimer = () => {
      const now = new Date();
      const diff = expiryDate - now;

      if (diff <= 0) {
        setTimeLeft("Expired");
        return;
      }

      const duration = dayjs.duration(diff);

      const formatted = `${duration.days()}d ${duration.hours()}h ${duration.minutes()}m`;
      setTimeLeft(formatted);
    };

    updateTimer(); 
    const interval = setInterval(updateTimer, 60000);

    return () => clearInterval(interval);
  }, [createdAt]);

  return (
    <div style={{ color: "red", marginTop: "10px" }}>
      {timeLeft === "Expired" ? (
        <strong>⚠️ This order has expired</strong>
      ) : (
        <span>🕒 Payment expires in <strong>{timeLeft}</strong></span>
      )}
    </div>
  );
};

export default PaymentExpiryTimer;
